interface LogoProps {
    className?: string,
    primaryColor?: string,
    secondaryColor?: string,
    backgroundColor?: string
}

export default function Logo({
                                 className,
                                 primaryColor = 'black',
                                 secondaryColor = '#444',
                                 backgroundColor = '#C8242B'
                             }: LogoProps): JSX.Element {
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1013 354"
             className={`${className ?? ''}`}>
            <g id="Artwork_191" data-name="Artwork 191">
                <g>
                    <rect fill={backgroundColor} x="360.1" y="45.13" width="262.92" height="263.66"/>
                    <polygon fill={primaryColor}
                             points=".78 68.3 .78 97.64 36.75 97.64 36.75 285.92 67.83 285.92 67.83 97.64 103.79 97.64 103.79 68.3 .78 68.3"/>
                    <path fill={primaryColor}
                          d="M113.68,120.4c0-34.95,25.65-52.41,49.83-52.41s49.86,17.46,49.86,52.41v113.24c0,34.94-25.65,52.41-49.86,52.41s-49.83-17.46-49.83-52.41v-113.24ZM143.42,233.65c0,14.75,9.33,21.68,20.09,21.68s20.14-6.93,20.14-21.68v-113.24c0-14.77-9.33-21.69-20.14-21.69s-20.09,6.93-20.09,21.69v113.24Z"/>
                    <path fill={primaryColor}
                          d="M236.31,68.22h46.62c17.07,0,29.56,3.97,40.25,15.28,10.65,11.3,14,25.05,14,51.03,0,18.95-1.52,31.79-8.83,43.71-8.52,14.06-22.24,22.62-45.1,22.62h-15.85v84.97h-31.08V68.22ZM267.39,171.51h14.93c25.31,0,25.6-14.97,25.6-36.68,0-20.46,0-37.28-24.37-37.28h-16.17v73.96Z"/>
                    <polygon fill="white"
                             points="600.57 68.1 566.14 68.1 538.7 135.03 511.24 68.1 383.02 68.1 383.02 285.83 414.41 285.83 414.41 190.52 457.76 190.52 457.76 163.49 414.41 163.49 414.41 95.51 488.09 95.51 521.49 177.01 476.85 285.92 511.24 285.92 538.7 218.99 566.14 285.92 600.57 285.92 555.91 177.01 600.57 68.1"/>
                    <g>
                        <path fill={secondaryColor}
                              d="M660.46,80.16h41.81c12.55,0,22.51,1.89,29.9,5.68,7.38,3.79,13.01,8.54,16.89,14.25,3.88,5.72,6.37,12.04,7.48,18.97,1.1,6.92,1.66,13.43,1.66,19.51v3.88c0,8.69-.92,16.53-2.77,23.53-1.85,7.02-4.84,12.98-8.99,17.87-4.16,4.89-9.7,8.67-16.62,11.34-6.92,2.68-15.46,4.01-25.61,4.01h-11.91v74.76h-31.84V80.16ZM692.3,170.13h12.73c4.62,0,8.31-.69,11.07-2.07,2.77-1.39,4.95-3.28,6.51-5.68,1.57-2.4,2.58-5.26,3.04-8.58.46-3.32.7-6.92.7-10.79v-7.76c0-4.43-.33-8.26-.97-11.48-.65-3.23-1.89-5.96-3.74-8.17-1.85-2.22-4.38-3.83-7.62-4.86-3.23-1-7.44-1.52-12.59-1.52h-9.14v60.91Z"/>
                        <path fill={secondaryColor}
                              d="M840.7,273.96l-7.75-40.42h-34.89l-8.3,40.42h-30.73l38.48-193.8h35.99l38.2,193.8h-31ZM814.94,133.87l-13.29,70.87h26.59l-13.29-70.87Z"/>
                        <path fill={secondaryColor}
                              d="M933.45,193.39v80.57h-31.85v-81.39l-40.97-112.41h34.89l21.6,73.64h2.21l21.04-73.64h33.77l-40.69,113.23Z"/>
                    </g>
                    <path fill={backgroundColor}
                          d="M1010.08,47.39v259.34h-385.55V47.39h385.55M1012.22,45.25h-389.84v263.62h389.84V45.25h0Z"/>
                </g>
            </g>
        </svg>);
}
